import React, {useContext} from "react";
import * as styles from "./ApplicationAndBranchListing.module.less";
import { TeaserGrid } from "../../../components/teaser-components/TeaserGrid/TeaserGrid";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

export function ApplicationAndBranchListing({ items = [] }) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);
    return (
        <div className={gcs(styles.container, [
            showAnchorNavigation,
            styles.anchored
        ])}>
            <TeaserGrid
                teaserList={items}
                sliderOnMobile={true}
                semanticOfTeaserHeadline={"H4"}
                maxElements={999}
                teaserClass={styles.applicationTeaser}
                hasLightBackground={false}
            />
        </div>
    );
}
